/**
 * Run async factories in array order with bounded concurrency.
 * Helps avoid overwhelming the API with many parallel requests.
 */
export async function promisePool<T>(factories: Array<() => Promise<T>>, concurrency: number): Promise<T[]> {
  if (factories.length === 0) return [];
  const results: T[] = new Array(factories.length);
  let nextIndex = 0;
  const limit = Math.max(1, Math.floor(concurrency) || 1);
  const poolSize = Math.min(limit, factories.length);

  const worker = async () => {
    for (;;) {
      const i = nextIndex++;
      if (i >= factories.length) return;
      results[i] = await factories[i]();
    }
  };

  await Promise.all(Array.from({ length: poolSize }, () => worker()));
  return results;
}
